import API from "./restAPI";
import { AxiosResponse } from "axios";

let config = require("../configuration.json");

export function apiGetReceipts(productId: number): Promise<AxiosResponse> {
  return API.get(
    `${config.serverUrl}/api/receipts/${productId}`
  );
}

export function apiGetReceiptsCustom(productId: number): Promise<AxiosResponse> {
  return API.get(
    `${config.serverUrl}/api/receiptsCustom/${productId}`
  );
}

export function apiCreateReceiptsCopyJob(data: any): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/receiptscopyCreateJob`, data);
}

export function apiProcessReceiptsCopyJob(jobIdentifier: string): Promise<AxiosResponse> {

  return API.post(`${config.serverUrl}/api/receiptsprocessCopyJob/${jobIdentifier}`);
}

export function apiLoadReceiptsCopyJob(jobIdentifier: string): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/receiptsloadCopyJob/${jobIdentifier}`);
}

export function apiCreateReceiptsImportJob(data: any): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/receiptsimportCreateJob`, data);
}

export function apiDeleteReceipt(id: number): Promise<AxiosResponse> {
  return API.delete(`${config.serverUrl}/api/receipt/${id}`);
}

export function apiReceiptCreateOrUpdate(data: any): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/receiptcreateorupdate`, data);
}

export function apiGetReceiptById(
  receiptId: number,
): Promise<AxiosResponse> {

  return API.get(
    `${config.serverUrl}/api/receipt/${receiptId}`
  );
}

export function apiGetReceipt(
  colorId: number,
  productId: number,
  baseId: number,
  userId?: number
): Promise<AxiosResponse> {
  if (userId) {
    return API.get(
      `${config.serverUrl}/api/receipt/${colorId}/${productId}/${baseId}/${userId}`
    );
  } else {
    return API.get(
      `${config.serverUrl}/api/receipt/${colorId}/${productId}/${baseId}`
    );
  }
}

export function apiGetPossibleBasisFromReceipt(
  colorId: number,
  productId: number,
  userId?: number
): Promise<AxiosResponse> {
  if (userId) {
    return API.get(
      `${config.serverUrl}/api/possiblebasisfromreceipt/${colorId}/${productId}/${userId}`
    );
  } else {
    return API.get(
      `${config.serverUrl}/api/possiblebasisfromreceipt/${colorId}/${productId}`
    );
  }
}
